export enum TableCellEntityMode {
  enabled = 'enabled',
  disabled = 'disabled',
}
